<template>
  <main class="view home" v-if="!kql.loading">
    <section class="hero">
      <h1 v-html="kql.page?.title" />
      <p class="tagline" v-html="kql.page?.tagline" />
    </section>
    <section class="content" v-if="layout">
      <LayoutComponent :layout="layout" :context="kql.page" />
    </section>
    <MainFooter />
  </main>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import { yamlToObject } from '@/utils'

const kql = useStore()
const layout = computed(() => yamlToObject(kql.page?.layout))
</script>

<style scoped>
.home {
  padding-top: var(--header-height);
}

.hero {
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 4rem var(--offset) 6rem;
  gap: 3rem;
}

.tagline {
  font-family: var(--serif);
  font-size: clamp(16px, 1.8vw, 24px);
  line-height: 1.5;
  max-width: 40em;
  opacity: 0.6;
  margin: 0;
}

.content {
  padding: 6rem var(--offset);
}
</style>
